export var Role;
(function (Role) {
    Role["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    /** Regular group member. */
    Role["MEMBER"] = "MEMBER";
    /** Group administrator. */
    Role["ADMIN"] = "ADMIN";
})(Role || (Role = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var MembershipStatus;
(function (MembershipStatus) {
    MembershipStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Site member is a group member. */
    MembershipStatus["JOINED"] = "JOINED";
    /** Site member has join group request with `PENDING` status for this group. */
    MembershipStatus["PENDING"] = "PENDING";
})(MembershipStatus || (MembershipStatus = {}));
//# sourceMappingURL=types.js.map